const STEAM_TRANSACTION_STATUSES = {
    INITED: 'inited',
    SUCCEEDED: 'succeeded',
    CANCELLED: 'cancelled',
    EXPIRED: 'expired',
};

export { STEAM_TRANSACTION_STATUSES };
//# sourceMappingURL=steamTransactionStatuses.js.map
